module.exports = __webpack_public_path__ + "static/media/pets-24px.ae11bd9e.svg";